import React from "react"
import "./Card.css"

const Card = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <div ref={ref} className={`card ${className || ""}`} {...props}>
      {children}
    </div>
  )
})

Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <div ref={ref} className={`card-header ${className || ""}`} {...props}>
      {children}
    </div>
  )
})

CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <h3 ref={ref} className={`card-title ${className || ""}`} {...props}>
      {children}
    </h3>
  )
})

CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <p ref={ref} className={`card-description ${className || ""}`} {...props}>
      {children}
    </p>
  )
})

CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <div ref={ref} className={`card-content ${className || ""}`} {...props}>
      {children}
    </div>
  )
})

CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <div ref={ref} className={`card-footer ${className || ""}`} {...props}>
      {children}
    </div>
  )
})

CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }

